export default api => ({
    usersList: params => api.get('/admin/users', params),
    usersCreate: params => api.post('/admin/users', params),
    usersDetail: ({ id }) => api.get(`/admin/users/${id}`),
    usersEdit: ({ id, params }) => api.put(`/admin/users/${id}`, params),
    usersDelete: ({ id }) => api.delete(`/admin/users/${id}`),
})
